import React, { useEffect } from "react";
import ReactPaginate from "react-paginate";
import PropTypes from "prop-types";
import CustomSpan from "./CustomSpan";
import CustomImg from "./CustomImg";
import arrowLeftIcon from "../assets/icons/arrow-left-icon.png";
import arrowRightIcon from "../assets/icons/arrow-right-icon.png";
import { ITEMS_PER_PAGE } from "../constants/app";
import { SelectInput } from "./form";

function Pagination(props) {
  const {
    currentPage,
    pageSize,
    totalCount,
    setPage,
    setPageSize,
    children,
    showIndex,
    numPages,
  } = props;
  const totalPages = numPages ? numPages : Math.ceil(totalCount / pageSize);

  const startIndex = Math.min((currentPage - 1) * pageSize + 1, totalCount);
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  function handlePageClick(pageNumber) {
    setPage(pageNumber + 1);
  }

  function handlePageSizeClick(pageNumber) {
    setPageSize(pageNumber);
  }

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    if (currentPage > newTotalPages) {
      setPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize]);

  const perPageOptions = () => {
    return ITEMS_PER_PAGE.map((item, index) => ({
      value: item,
      label: `${item}件`,
    }));
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="whitespace-nowrap">
        {children}
        {setPageSize && (
          <SelectInput
            options={perPageOptions()}
            className="w-20 xl:mr-4 mr-2"
            value={props.pageSize}
            onChange={(e) => handlePageSizeClick(Number(e.target.value))}
          />
        )}
        {showIndex && totalCount > 0 && (
          <CustomSpan
            text={`${totalCount}件中${startIndex}～${endIndex}件を表示`}
            classes="lg:text-base text-[15px]"
          />
        )}
      </div>
      <div className="flex ml-10">
        {totalPages > 1 && (
          <ReactPaginate
            nextLabel={
              <div className="flex items-center">
                <CustomSpan
                  className="2xl:mr-[8px] xl:mr-[6px] md:mr-[4px] lg:text-base text-[15px]"
                  text="次"
                />
                <CustomImg
                  src={arrowRightIcon}
                  className="2xl:w-[20px] 2xl:h-[20px] xl:w-[18px] xl:h-[18px] md:w-[16px] md:h-[16px]"
                  alt="Next icon"
                />
              </div>
            }
            initialPage={currentPage - 1}
            onPageChange={(selected) => handlePageClick(selected.selected)}
            pageCount={totalPages}
            previousLabel={
              <div className="flex items-center">
                <CustomImg
                  src={arrowLeftIcon}
                  className="2xl:w-[20px] 2xl:h-[20px] xl:w-[18px] xl:h-[18px] md:w-[16px] md:h-[16px]"
                  alt="Previous icon"
                />
                <CustomSpan
                  className="2xl:ml-[8px] xl:ml-[6px] md:ml-[4px] lg:text-base text-[15px]"
                  text="前"
                />
              </div>
            }
            pageClassName="flex items-center justify-center 2xl:w-16 xl:h-10 xl:w-12 md:w-10 md:h-[38px] bg-white border border-[#D0D5DD] hover:bg-gray-100 cursor-pointer lg:text-base text-[15px]"
            pageLinkClassName="2xl:px-[16px] 2xl:py-[10px] xl:px-[14px] xl:py-[8px] md:px-[12px] md:py-[6px]"
            previousClassName="flex items-center justify-center 2xl:w-16 xl:h-10 xl:w-14 md:w-11 md:h-[38px] bg-white border rounded-l-lg border-[#D0D5DD] hover:bg-gray-100 cursor-pointer lg:text-base text-[15px]"
            previousLinkClassName="w-full h-full flex justify-center"
            nextClassName="flex items-center justify-center 2xl:w-16 xl:h-10 xl:w-14 md:w-11 md:h-[38px] bg-white border rounded-r-lg border-[#D0D5DD] hover:bg-gray-100 cursor-pointer lg:text-base text-[15px]"
            nextLinkClassName="w-full h-full flex justify-center"
            breakLabel="..."
            breakClassName="flex items-center justify-center 2xl:w-16 xl:h-10 xl:w-12 md:w-10 md:h-[38px] bg-white border border-[#D0D5DD] hover:bg-gray-100 cursor-pointer lg:text-base text-[15px]   "
            breakLinkClassName="text-sm"
            containerClassName="flex space-x-0"
            activeClassName="pagination-active text-[#2E90FA] border border-[#D0D5DD]"
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            renderOnZeroPageCount={null}
          />
        )}
      </div>
    </div>
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  setPage: PropTypes.func,
  setPageSize: PropTypes.func,
  showIndex: PropTypes.bool,
};

Pagination.defaultProps = {
  showIndex: true,
};
export default Pagination;
